import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";
import {find, on, findAll, closest} from "@elements/dom-utils";

import Modal from 'bootstrap/js/dist/modal';
onFind('[data-bs-toggle="modal"]',function (element) {
    new Modal(element);
});

import Collapse from 'bootstrap/js/dist/collapse';
onFind('[data-bs-toggle="collapse"]',function (element) {
    new Collapse(element);
});

import * as fileInput from '@elements/file-input';
fileInput.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as ajaxFormScrollTop from './scripts/ajax-form-scroll-top';
ajaxFormScrollTop.init();

import * as editFormBox from './scripts/edit-form-box'
editFormBox.init();

import * as qrScanner from './scripts/qr-scanner';
qrScanner.init();

import * as addressFormToggle from './scripts/address-form-toggle'
addressFormToggle.init();

import * as keycard from './scripts/keycard';
keycard.init();

import * as dateInput from '@elements/date-input';
dateInput.init(
    {
        placeholderDate: false
    }
);

import * as sidenavAnimations from './scripts/sidenav-animations'
sidenavAnimations.init()

import * as warning from './scripts/warning'
warning.init();
